import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { DirectivesModule } from '@library/ui/directives/directives.module';
import { PreviewGraphComponent } from '@library/ui/molecules/preview-graph/preview-graph.component';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';

@Component({
  selector: 'app-pressure-card',
  imports: [PreviewGraphComponent, TextModule, AsyncPipe, PipesModule, DirectivesModule],
  templateUrl: './pressure-card.component.html',
  styleUrl: './pressure-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PressureCardComponent {
  private readonly weathermapFacade = inject(WeathermapFacade);

  type = EnumMeasureTypes.PRESSURE;

  station = this.weathermapFacade.selectedStation;

  getValue(): number {
    return this.station().Pressure?.[this.station().Pressure?.length - 1].y ?? null;
  }
}
